<template>
    <main>
        <section class="hero">
            <div class="lg:tw-container tw-flex tw-flex-col lg:tw-flex-row lg:tw-justify-between lg:tw-gap-5">
                <div class="info lg:tw-pt-12">
                    <small class="tw-hidden lg:tw-block tw-text-4xl tw-uppercase tw-text-white tw-font-thin lg:tw-text-left">9 DE NOVEMBRO</small>
                    <p class="tw-text-center lg:tw-text-left tw-text-white lg:tw-pb-6"><span class="lg:tw-hidden">Curso </span>Como criar uma<br class="tw-hidden lg:tw-block">Carteira de Investimento</p>
                    <h1 class="tw-block tw-text-center lg:tw-text-left tw-text-white lg:tw-px-0 lg:tw-pb-6">Abra a sua conta e aceda <span>gratuitamente</span> a uma<br class="tw-hidden lg:tw-block"><span>Formação Oficial</span> pela Deco Proteste / Proteste Investe.</h1>
                    <div class="images-container tw-hidden lg:tw-flex tw-gap-5 tw-mb-4">
                        <img src="~@/assets/img/deco.svg">
                        <img src="~@/assets/img/protest-invest.svg">
                    </div>
                    <h1 class="tw-hidden lg:tw-block tw-text-4xl tw-text-white tw-uppercase">CURSO <b>EXCLUSIVO PARA CLIENTES INVEST BTRADER</b></h1>
                </div>
                <div class="form-container tw-mt-3 lg:tw-mt-0 tw-relative">
                    <Form v-if="!$store.state.formSuccess" />
                    <FormSuccess v-if="$store.state.formSuccess" />
                </div>
            </div>
        </section>

        <section class="strategies"> 
            <div class="tw-container tw-py-5">
                <h1 class="tw-text-left tw-pb-6">Formação Oficial <span>"Como criar uma Carteira de Investimento"</span> Deco Proteste Investe Exclusivo Clientes Invest BTrader</h1>
                <p class="tw-text-left">O curso <b>“Como criar uma Carteira de Investimento”</b> é uma formação Oficial pela <b>Deco Proteste Investe</b>, e aborda metodologias de atuação sobre os investimentos em geral e sobre o mercado bolsista em particular, fundamentais para criar uma carteira equilibrada, numa perspetiva de risco e rendimento. Para aproveitar as oportunidades constantes que os mercados oferecem é necessário conhecer os conceitos fundamentais e saber aplicar as regras essenciais para investir e rentabilizar o capital.</p>
                <p class="tw-text-left">O curso é online e tem a duração de 4 horas.</p>
                <p class="tw-text-left tw-pb-8"><b>DATA:</b>9 de Novembro</p>
            </div>
        </section>

        <section class="free-ebook">
            <div class="tw-container tw-flex tw-flex-col tw-items-center tw-justify-center lg:tw-flex-row lg:tw-justify-between">
                <div class="tw-hidden lg:tw-block"><h1 class="tw-text-white tw-text-center lg:tw-text-left tw-pb-4 lg:tw-pb-0">Inscrições limitadas. Não perca esta oportunidade.</h1></div>
                <div class="tw-flex tw-items-center tw-justify-center lg:tw-justify-end"><button v-scroll-to="'.hero'" class="btn-page tw-w-full lg:tw-w-auto tw-outline-none tw-text-white tw-text-center tw-uppercase">INSCRIÇÃO GRATUITA <span style="transform: rotate(-90deg);">❯</span></button></div>
            </div>
        </section>
    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
};
</script>
